import { invalidate, useQueryClient } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import type { IncomingInvoiceApprovalDecisionSchema } from "@msuite/utils/schemas";
import { useState } from "react";
import { client } from "@/hono";

/**
 * Decide an approval and refresh every reader of it: the invoice, the invoice list whose state
 * column it may move, and the dashboard's open approvals.
 */
export function useDecideIncomingInvoiceApproval() {
	/** Hooks */
	const qc = useQueryClient();

	/** State */
	const [isDeciding, setIsDeciding] = useState(false);

	/** Functions */
	async function decide(
		incomingInvoiceId: string,
		approvalId: string,
		json: IncomingInvoiceApprovalDecisionSchema,
	) {
		try {
			setIsDeciding(true);
			const response = await client.incoming_invoices[":incomingInvoiceId"].approvals[
				":approvalId"
			].$patch({ param: { incomingInvoiceId, approvalId }, json });
			await responseHandler(response);
			await qc.invalidateQueries({
				predicate: invalidate(["incoming-invoices", "incoming-invoice-approvals-mine"]),
			});
		} finally {
			setIsDeciding(false);
		}
	}

	/** Return */
	return { decide, isDeciding };
}
